// Sets up the public path for webpack,
// so it knows where to download the JS assets from (i.e. the CDN)
// If this is not setup correctly, then webpack will try to download chunks from the server root
/* global __webpack_public_path__:true */
__webpack_public_path__ = `${window.__CONFIG__.roots.js_root}/`;
